import { render, staticRenderFns } from "./activity-edit-main.vue?vue&type=template&id=587d20f4&scoped=true&"
import script from "./activity-edit-main.vue?vue&type=script&lang=js&"
export * from "./activity-edit-main.vue?vue&type=script&lang=js&"
import style0 from "./activity-edit-main.vue?vue&type=style&index=0&id=587d20f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d20f4",
  null
  
)

export default component.exports